export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10308.5fe0687f.jpg";